import { render, staticRenderFns } from "./CadastroDescontoTipo.vue?vue&type=template&id=cb007428&"
import script from "./CadastroDescontoTipo.vue?vue&type=script&lang=js&"
export * from "./CadastroDescontoTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports